import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { QueryBuilderCompatComponent } from './query-builder-compat.component';
import {
  QueryButtonGroupDirective,
  QueryFieldDirective,
  QueryInputDirective,
  QueryOperatorDirective,
  QueryRemoveButtonDirective,
  QuerySwitchGroupDirective,
} from './template-directives';

@NgModule({
  declarations: [
    QueryBuilderCompatComponent,
    QueryButtonGroupDirective,
    QueryFieldDirective,
    QueryInputDirective,
    QueryOperatorDirective,
    QueryRemoveButtonDirective,
    QuerySwitchGroupDirective,
  ],
  imports: [CommonModule, TranslateModule],
  exports: [
    QueryBuilderCompatComponent,
    QueryButtonGroupDirective,
    QueryFieldDirective,
    QueryInputDirective,
    QueryOperatorDirective,
    QueryRemoveButtonDirective,
    QuerySwitchGroupDirective,
  ],
})
export class QueryBuilderCompatModule {}
